import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import React, {FC} from 'react';
import {useTrackFeature} from '../trackingHooks/useTrackFeature';
import {BaseTracker, BaseTrackerProps} from './BaseTracker';

interface Props extends Omit<BaseTrackerProps, 'track'> {
  productId: Product['id'];
}

export const TrackSizeChartCTA: FC<Props> = ({
  productId,
  children,
  ...rest
}) => {
  const trackFeature = useTrackFeature();

  const handleTrackFeature = () => {
    return (type: 'impression' | 'click') => {
      trackFeature({eventType: type, label: `size_chart|${productId}`});
    };
  };

  return (
    <BaseTracker
      threshold={0.5}
      triggerOnce={true}
      track={handleTrackFeature}
      {...rest}
    >
      {children}
    </BaseTracker>
  );
};
